import React, { Component } from 'react';
import './styles';
import Launcher from './components/Launcher';

export { Launcher };